import React from 'react';
import PropTypes from 'prop-types';
import { useGetCompSeasonQuery } from 'common/store/modules/api/afl-api';
import { useGetContentQuery } from 'common/store/modules/api/content-api';
import { Sponsor } from '../sponsor/Sponsor';

/**
 * Team Lineups Sponsor component
 * Obtains competition id for the given compSeasonId, then fetches PROMOs for the obtained competition id
 *
 * @param {object} props
 * @param {string} props.compSeasonId Comp Season ID
 * @param {string} props.cssClass Custom css class, added to the Sponsor element
 * @returns
 */
export const TeamLineupsSponsor = ({ compSeasonId, cssClass = '' }) => {
    // getting compseason details to get the competition id
    const { data: compSeason } = useGetCompSeasonQuery(
        {
            id: compSeasonId
        },
        {
            skip: !compSeasonId
        }
    );

    // fetching sponsor PROMOs for the competition
    const { data: promo } = useGetContentQuery(
        {
            type: 'PROMO',
            params: {
                tagNames: PULSE.app.common.CONSTANTS.TAGS.LINEUPS_SPONSOR,
                referenceExpression: `AFL_COMPETITION:${compSeason?.competition?.id}`
            }
        },
        {
            skip: !compSeason || !compSeason?.competition?.id
        }
    );

    return (
        promo?.content?.length > 0 && (
            <Sponsor
                promoPayload={promo.content[0]}
                imageHeight={120}
                cssClass={cssClass}
            />
        )
    );
};

TeamLineupsSponsor.propTypes = {
    compSeasonId: PropTypes.string,
    cssClass: PropTypes.string
};
